import React from 'react';
import classNames from 'classnames';
import Styles from './status-box.less'

const baseClass = Styles.statusBox;

const classes = {
  'live': Styles.statusBoxLive,
  'approved': Styles.statusBoxApproved,
  'handedin': Styles.statusBoxHandedin,
  'active': Styles.statusBoxActive,
  'passed': Styles.statusBoxPassed,
  'assessed': Styles.statusBoxAssessed,
  'moderationcomplete': Styles.statusBoxModeratConomplete,
  'satisfactory': Styles.statusBoxSatisfactory,
  'moderationneeded': Styles.statusBoxModerationNeeded,

  'readyforreview': Styles.statusBoxReadyForReview,
  'ongoing': Styles.statusBoxOngoing,
  'readyforassessing': Styles.statusBoxReadyForAssessing,
  'moderationnotneeded': Styles.statusBoxModerationNotNeeded,

  'notapproved': Styles.statusBoxNotApproved,
  'void': Styles.statusBoxVoid,
  'failed': Styles.statusBoxFailed,
  'notsatisfactory': Styles.statusBoxNotSatisfactory,

  'undefined': Styles.statusBoxUndefined,
  'notstarted': Styles.statusBoxNotstarted,
  'archived': Styles.statusBoxArchived,
  'notsubmitted': Styles.statusBoxNotSubmitted,

  'draft': Styles.statusBoxDraft,
  'paused': Styles.statusBoxPaused,
  'pending': Styles.statusBoxPending,
  'moderationinprogress': Styles.statusBoxModerationInProgress,
  'waitingforcoassessors': Styles.statusBoxWaitingForCoassessors,
  'inprogress': Styles.statusBoxInprogress,
  'assessing': Styles.statusBoxAssessing,
  'waitingformoderator': Styles.statusBoxWaitingForModerator,

  'warning': Styles.statusBoxWarning,
  'ok': Styles.statusBoxOk,
  'na': Styles.statusBoxNA
};

module.exports = React.createClass({
  propTypes: {
    className: React.PropTypes.string,
    type: React.PropTypes.string.isRequired,
    text: React.PropTypes.string.isRequired
  },
  getClass() {
    var typeClass = classes[this.props.type] || '';
    return classNames(this.props.className, baseClass, typeClass);
  },
  render: require('./status-box.rt')
});



/** WEBPACK FOOTER **
 ** ./src/status-boxes/status-box/index.js
 **/